export const types = {
  OPEN_DIALOG_ADD_TO_CART: '@ACTIONS/OPEN_DIALOG_ADD_TO_CART',
  CLOSE_DIALOG_ADD_TO_CART: '@ACTIONS/CLOSE_DIALOG_ADD_TO_CART',
  OPEN_DIALOG_CREATE_ALERT: '@ACTIONS/OPEN_DIALOG_CREATE_ALERT',
  CLOSE_DIALOG_CREATE_ALERT: '@ACTIONS/CLOSE_DIALOG_CREATE_ALERT',
  OPEN_DIALOG_ADD_TO_NEWSLETTER: '@ACTIONS/OPEN_DIALOG_ADD_TO_NEWSLETTER',
  CLOSE_DIALOG_ADD_TO_NEWSLETTER: '@ACTIONS/CLOSE_DIALOG_ADD_TO_NEWSLETTER',
  OPEN_DIALOG_SEND_TO_FRIEND: '@ACTIONS/OPEN_DIALOG_SEND_TO_FRIEND',
  CLOSE_DIALOG_SEND_TO_FRIEND: '@ACTIONS/CLOSE_DIALOG_SEND_TO_FRIEND',
  OPEN_DIALOG_EXPORT: '@ACTIONS/OPEN_DIALOG_EXPORT',
  CLOSE_DIALOG_EXPORT: '@ACTIONS/CLOSE_DIALOG_EXPORT',
  OPEN_DIALOG_UPLOAD_FILES: '@ACTIONS/OPEN_DIALOG_UPLOAD_FILES',
  CLOSE_DIALOG_UPLOAD_FILES: '@ACTIONS/CLOSE_DIALOG_UPLOAD_FILES',
  OPEN_SIDENAV_SUMMARIZE: '@ACTIONS/OPEN_SIDENAV_SUMMARIZE',
  CLOSE_SIDENAV_SUMMARIZE: '@ACTIONS/CLOSE_SIDENAV_SUMMARIZE',
};

export const openDialogAddToCart = () => ({
  type: types.OPEN_DIALOG_ADD_TO_CART,
});

export const closeDialogAddToCart = () => ({
  type: types.CLOSE_DIALOG_ADD_TO_CART,
});

export const openDialogCreateAlert = () => ({
  type: types.OPEN_DIALOG_CREATE_ALERT,
});

export const closeDialogCreateAlert = () => ({
  type: types.CLOSE_DIALOG_CREATE_ALERT,
});

export const openDialogAddToNewsletter = () => ({
  type: types.OPEN_DIALOG_ADD_TO_NEWSLETTER,
});

export const closeDialogAddToNewsletter = () => ({
  type: types.CLOSE_DIALOG_ADD_TO_NEWSLETTER,
});

export const openDialogSendToFriend = () => ({
  type: types.OPEN_DIALOG_SEND_TO_FRIEND,
});

export const closeDialogSendToFriend = () => ({
  type: types.CLOSE_DIALOG_SEND_TO_FRIEND,
});

export const openDialogExport = () => ({
  type: types.OPEN_DIALOG_EXPORT,
});

export const closeDialogExport = () => ({
  type: types.CLOSE_DIALOG_EXPORT,
});

export const openDialogUploadFiles = (idCorpus) => ({
  type: types.OPEN_DIALOG_UPLOAD_FILES,
  idCorpus,
});

export const closeDialogUploadFiles = () => ({
  type: types.CLOSE_DIALOG_UPLOAD_FILES,
});

export const openSidenavSummarize = () => ({
  type: types.OPEN_SIDENAV_SUMMARIZE,
});

export const closeSidenavSummarize = () => ({
  type: types.CLOSE_SIDENAV_SUMMARIZE,
});
